export default function Field({ label, testid, type = 'text', value, onChange, placeholder, dir, min, max }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-bold text-brand-steel">{label}</span>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        dir={dir}
        min={min}
        max={max}
        className={inputCls}
      />
    </label>
  );
}

import { inputCls } from '@/lib/api';

export { inputCls };
